module.exports = __webpack_public_path__ + "img/Dine-in Icon - charcoal.a9699468.svg";